<template>
  <el-dialog
    title="填写通过备注"
    :visible.sync="showPassDialog"
    :width="isSecondApprove ? '40%' : '30%'"
    top="15%"
  >
    <div class="dialog-amount-box" v-if="isFirstApprove">
      <span class="label">
        <span style="color: red">*</span>
        应付金额：
      </span>
      <AmountInput
        class="amount-input"
        v-model="approveAmount"
        :max="maxAmount"
        placeholder="请输入应付金额（必填）"
      >
      </AmountInput>
    </div>
    <div class="dialog-score-box" v-if="isSecondApprove">
      <el-table :data="scoreTable" style="width: 100%" stripe>
        <el-table-column label="评分类型" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.name }}</template>
        </el-table-column>
        <el-table-column
          label="分数"
          header-align="center"
          align="right"
          width="150"
        >
          <template slot-scope="scope">{{
            Number(scope.row.value || 0).toFixed(6)
          }}</template>
        </el-table-column>
      </el-table>
      <div class="score-total">
        <span>综合评分：</span>
        <span class="score-total-num">{{ comprehensiveScoreDisplay }}</span>
      </div>
    </div>
    <el-input
      type="textarea"
      :rows="5"
      placeholder="请填写通过备注（选填）"
      v-model="approveSuggest"
      maxlength="100"
    >
    </el-input>
    <span slot="footer" class="dialog-footer">
      <el-button type="info" class="w100f" @click="handleSubmit"
        >通过</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import AmountInput from "@/components/AmountInput/index.vue";
export default {
  name: "PassSettlementBillDialog",
  components: {
    AmountInput,
  },
  data() {
    return {
      showPassDialog: false,
      isFirstApprove: false, // 当前审批人是否是第一个
      isSecondApprove: false, // 当前审批人是否是第二个
      maxAmount: undefined, // 应付金额最大值（结算金额合计）
      scoreTable: [],
      comprehensiveScore: null, // 综合评分
      approveAmount: "",
      approveSuggest: "",
    };
  },
  computed: {
    // 综合评分（四舍五入保留两位）
    comprehensiveScoreDisplay() {
      return Number(this.comprehensiveScore || 0).toFixed(2);
    },
  },
  methods: {
    open(data) {
      this.isFirstApprove = data.isFirstApprove;
      this.isSecondApprove = data.isSecondApprove;
      this.maxAmount = data.maxAmount;
      this.scoreTable = [...data.scoreTable] || [];
      this.comprehensiveScore = data.comprehensiveScore;
      this.approveAmount = "";
      this.approveSuggest = "";
      this.showPassDialog = true;
    },
    close() {
      this.showPassDialog = false;
    },
    handleSubmit() {
      if (this.isFirstApprove && !this.approveAmount) {
        this.$message.error("请填写应付金额");
        return;
      }
      this.$emit("submit", {
        approveAmount: this.approveAmount,
        approveSuggest: this.approveSuggest,
      });
    },
  },
};
</script>

<style scoped>
.dialog-amount-box {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  .label {
    flex-shrink: 0;
    width: 90px;
    text-align: right;
    margin-right: 6px;
    color: #666666;
  }

  .amount-input {
    flex: 1;
  }
}
.dialog-score-box {
  margin-bottom: 10px;

  .score-total {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 8px 10px;
    color: #212121;

    .score-total-num {
      color: #ff5f1f;
      font-weight: 600;
    }
  }
}
</style>
